<template>
	<div class="main-container">
        <v-container class="pa-0 r-p-x-0">
            <v-row no-gutters justify="center" align="center" class="py-16 bg-black">
                <EarnRewards></EarnRewards>
            </v-row>
            <v-row no-gutters justify="center" align="center" class="py-16 bg-black">
              
                <Communities></Communities>
            </v-row>
            <v-row no-gutters justify="center" align="center" class="py-16 bg-black" id="transparency">
                <Beyond></Beyond>
            </v-row>
            <v-row no-gutters justify="center" align="center" class="py-16 bg-black">
                <GetStarted></GetStarted>
            </v-row>
            <Footer class="bg-black"></Footer>
        </v-container>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import Beyond from './v3/components/Beyond.vue';
import Communities from './v3/components/Communities.vue';
import EarnRewards from './v3/components/EarnRewards.vue';
import Footer from './v3/components/Footer.vue';
import GetStarted from './v3/components/GetStarted.vue';
export default {
    data(){
        return {

        }
    },
    components: { Beyond, Communities, GetStarted, EarnRewards, Footer},
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(["darkTheme",'responsive'])
    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>